import { createContext, useContext, type ReactNode } from 'react';
import type { Socket } from 'socket.io-client';

interface SocketContextType {
  socket: Socket | null;
  connected: boolean;
}

const SocketContext = createContext<SocketContextType>({ socket: null, connected: false });

/**
 * Stub-Provider — pm-api hat keinen Socket.io-Endpunkt, daher wird keine
 * Verbindung aufgebaut. Konsumenten (NotificationContext) erhalten {socket:null}
 * und überspringen socket-spezifische Logik defensiv.
 */
export function SocketProvider({ children }: { children: ReactNode }) {
  return (
    <SocketContext.Provider value={{ socket: null, connected: false }}>
      {children}
    </SocketContext.Provider>
  );
}

export function useSocket() {
  return useContext(SocketContext);
}
